import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step4 } from '../../../../shared/models/component-messages/mapaAT/step4';
import { TypePers } from '../models/TypePers';
import {AutoCompleteService} from '../../../../shared/services/auto-complete.service';

@Component({
  selector: 'app-type-pers',
  templateUrl: './type-pers.component.html'
})
export class TypePersComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() personnePhysique: TypePers;
  @Input() rule: String;

  public optionsSelect: any[];
  public optionsSelectType = 'CIVILITE';

  public step4 = new Step4();

  constructor(private autoCompleteService: AutoCompleteService) { }

  public ngOnInit() {
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);

    if(!this.personnePhysique) {
      this.personnePhysique = new TypePers();
    }

    if (this.personnePhysique.civilite === null) {
      this.personnePhysique.civilite = '';
    }
  }

  getUid() {
    return this.uid + '_SepSep_TypePers';
  }
}
